import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Breadcrumbs from './../block/Breadcrumbs'
import LegalProductsOnMain from './../block/LegalProductsOnMain'

export default class Page extends Component {

  render() {

    const { ajax_data, data } = this.props

    return (
      <>
        <Breadcrumbs items={ajax_data.breadcrumbs} />
        <LegalProductsOnMain
          products={ajax_data?.ulcatalog || []}
          page_data={data?.page_data || {}}
        />
      </>
    )
  }
}

Page.propTypes = {
  data: PropTypes.object,
  ajax_data: PropTypes.object,
  cart: PropTypes.array,
  addTocart: PropTypes.func,
  authorized: PropTypes.bool
}